import { debugId, toDebugString } from "../debug";
import { EndpointError } from "../types";
import { callFunction } from "./callFunction";
export const evaluateCondition = (_ref, options) => {
  var _options$logger, _options$logger$debug;
  let {
    assign,
    ...fnArgs
  } = _ref;
  if (assign && assign in options.referenceRecord) {
    throw new EndpointError("'".concat(assign, "' is already defined in Reference Record."));
  }
  const value = callFunction(fnArgs, options);
  (_options$logger = options.logger) === null || _options$logger === void 0 || (_options$logger$debug = _options$logger.debug) === null || _options$logger$debug === void 0 || _options$logger$debug.call(_options$logger, debugId, "evaluateCondition: ".concat(toDebugString(fnArgs), " = ").concat(toDebugString(value)));
  return {
    result: value === "" ? true : !!value,
    ...(assign != null && {
      toAssign: {
        name: assign,
        value
      }
    })
  };
};